import React from "react";
import styled from "@emotion/styled";
export default function RichTextLight() {
  return <div>RichTextLight</div>;
}
